import { useState } from "react";
import { toast } from "sonner";
import { Send, Loader2 } from "lucide-react";
import { api, errText } from "../lib/api";
import { Button } from "./ui/button";
import { Textarea } from "./ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "./ui/dialog";

const defaultMsg = (title, fr) => (fr
  ? `Bonjour! J'ai vu votre annonce Recherché. J'ai ce que vous cherchez : « ${title} ». Jetez un coup d'œil et écrivez-moi si vous avez des questions!`
  : `Hi! I saw your ISO ad. I have what you're looking for: "${title}". Take a look and message me with any questions!`);

export const MessageIsoButton = ({ listing, left, fr, onSent }) => {
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState(() => defaultMsg(listing.title, fr));
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/my/listings/${listing.id}/message-iso`, { message: msg });
      toast.success(fr ? `Message envoyé à ${data.sent} acheteur(s)` : `Message sent to ${data.sent} ${data.sent === 1 ? "shopper" : "shoppers"}`,
        data.skipped ? { description: fr ? `${data.skipped} déjà contacté(s)` : `${data.skipped} already contacted` } : undefined);
      setOpen(false); onSent();
    } catch (e) { toast.error(errText(e)); }
    finally { setBusy(false); }
  };
  if (!left) return <p className="mt-3 text-xs font-semibold text-emerald-700" data-testid="iso-message-done">{fr ? "Vous avez écrit à tous ces acheteurs." : "You've messaged all of these shoppers."}</p>;
  return (
    <>
      <Button onClick={() => setOpen(true)} data-testid="iso-message-all-btn" className="mt-3 h-10 rounded-xl bg-[#12234A] hover:bg-[#1d3366] text-white gap-1.5">
        <Send size={15} /> {fr ? `Écrire aux ${left} acheteur(s)` : `Message ${left === 1 ? "this shopper" : `all ${left} shoppers`}`}
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-white sm:max-w-lg" data-testid="iso-message-dialog">
          <DialogHeader>
            <DialogTitle className="font-display text-[#12234A]">{fr ? "« J'ai ce que vous cherchez »" : "“I have what you're looking for”"}</DialogTitle>
            <DialogDescription>{fr ? `Chaque acheteur reçoit ce message en privé, avec un lien vers votre annonce. Envoyé une seule fois par acheteur.` : `Each shopper gets this privately in Messages, with a link to your ad. Sent once per shopper.`}</DialogDescription>
          </DialogHeader>
          <Textarea value={msg} onChange={(e) => setMsg(e.target.value)} rows={5} maxLength={1000} data-testid="iso-message-text" className="rounded-xl" />
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)} className="rounded-xl" data-testid="iso-message-cancel">{fr ? "Annuler" : "Cancel"}</Button>
            <Button onClick={send} disabled={busy || msg.trim().length < 5} className="rounded-xl bg-[#F5551E] hover:bg-[#E04812] text-white gap-1.5" data-testid="iso-message-send">
              {busy ? <Loader2 size={15} className="animate-spin" /> : <Send size={15} />} {fr ? "Envoyer" : `Send to ${left}`}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
